/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {FcResponsiveAgGridOptions} from './fc-responsive-ag-grid-options';

/**
 * Grid service with Angular.
 */
@Injectable({
    providedIn: 'root'
})
export class FcResponsiveAgGridService {

    /**
     * SelectionChanged Observable.
     */
    selectionChanged: BehaviorSubject<any> = new BehaviorSubject([]);


    /**
     * Default constructor.
     */
    constructor() {
    }

    /**
     * Get current items on current page for paging UI. 
     * 
     * @param allData All data list.
     * @param gridOptions AgGrid options.
     * @returns Object.
     */
    pagingUISide(allData: any[], gridOptions: FcResponsiveAgGridOptions): { data: any[], dataLength: number} {
        if (gridOptions && gridOptions.gridState && gridOptions.gridState.pageSize && 
            gridOptions.gridState.currentPage) {
            const to = gridOptions.gridState.pageSize * gridOptions.gridState.currentPage;
            return {
                data: allData.slice(to - gridOptions.gridState.pageSize, to),
                dataLength: allData.length
            };
        }
        
        return {
            data: [],
            dataLength: 0  
        };
    }
}